import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BuyflowVesselSortConfig } from '../../app/shared/buyflow-sort-filter-control/buyflow-sort-filter-control.component';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class BuyflowSortFilterService {
  private buyflowFilter = new BehaviorSubject<BuyflowVesselSortConfig>({
    bathrooms: 0,
    boatLengthMax: 500,
    boatLengthMin: 0,
    cabins: 0,
    passengers: 0,
    priceMax: 200000,
    priceMin: 0,
    showers: 0,
    sleeps: 0,
    availableOn: null,
    categories: [],
  });

  constructor() {}

  getBuyflowFilter(): BehaviorSubject<BuyflowVesselSortConfig> {
    return this.buyflowFilter;
  }

  resetBuyflowFilter(): void {
    this.buyflowFilter.next({
      bathrooms: 0,
      boatLengthMax: 500,
      boatLengthMin: 0,
      cabins: 0,
      passengers: 0,
      priceMax: 200000,
      priceMin: 0,
      showers: 0,
      sleeps: 0,
      availableOn: null,
      categories: [],
    });
  }
}
